import global from "../global.js";

const d3 = global.d3;

// const POSITION_DISTANCE = 15;
/*
var user_position = null;
var position_distance = (position_1, position_2) => {
    var {latitude: N1, longitude: E1} = position_1.coords;
    var {latitude: N2, longitude: E2} = position_2.coords;
    return d3.geoDistanceMeters([E1, N1], [E2, N2]);
};
*/

/*
if (user_position !== null && position_distance(user_position, position) < POSITION_DISTANCE) {
    position = user_position; // position has not moved more than 15 meters, reusing the old position
} else {
    user_position = position;
}
*/

const PositionTraceLine = function(group, color) {
    const render = d3.line().x(d => d[0]).y(d => d[1]).curve(d3.curveLinear);
    const points = [];
    const path = group.append("path")
        .attr("stroke", color)
        .attr("stroke-width", 3)
        .attr("stroke-opacity", 1)
        .attr("fill", "none");
    this.update = (x, y) => {
        points.push([x, y]);
        path.attr("d", render(points));
    };
    this.remove = () => {
        path.remove();
    };
};

const PositionTraceDisk = function(group, color) {
    const disks = group.append("g");
    this.update = (x, y) => {
        disks.append("circle")
            .attr("fill", color)
            .attr("cx", x)
            .attr("cy", y)
            .attr("r", 10);
    };
    this.remove = () => {
        disks.remove();
    };
};

const PositionTrace = {line: PositionTraceLine, disk: PositionTraceDisk};

const UsersDebug = function() {
    var trace_enabled = false, trace = [null, null];

    Object.defineProperty(this, "trace_enabled", {
        set: () => {},
        get: () => trace_enabled
    });

    this.trace_enable = (type) => {
        trace_enabled = true;
        trace[0] = new PositionTrace[type](global.scene.objects.layers.scene.group, "#7f00ff");
        trace[1] = new PositionTrace[type](global.scene.objects.layers.scene.group, "#ff00ff");
    };

    this.trace_disable = () => {
        trace_enabled = false;
        if (trace[0] !== null) {
            trace[0].remove();
            trace[0] = null;
        }
        if (trace[1] !== null) {
            trace[1].remove();
            trace[1] = null;
        }
    };

    this.trace_update = (n, x, y) => {
        if (!trace_enabled) {
            return;
        }
        trace[n].update(x, y);
    };
};

export default UsersDebug;
